import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import React, { ReactNode } from "react";

export interface TrackingContextProps {
	category: AnalyticsCategory;
	programId: string;
	children?: ReactNode;
}

export const TrackingContext = React.createContext<TrackingContextProps>({
	category: AnalyticsCategory.PROGRAM,
	programId: "",
});

export const TrackingContextProvider: React.FC<TrackingContextProps> = ({ category, programId, children }) => {
	const value = React.useMemo(() => ({ category, programId }), [category, programId]);
	return (
		<TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>
	);
};
